import { Flex, SkeletonText, Text } from '@billy/design-system'
import { Fragment, ReactElement } from 'react'

import { useExternalInvoiceTransactions } from '../../../../hooks/useExternalInvoiceTransactions'
import { InvoiceTransactionLink } from './elements/InvoiceTransactionLink'

export const InvoiceTransactionsList = (): ReactElement | ReactElement[] => {
  const { transactions, isLoading } = useExternalInvoiceTransactions()

  if (isLoading) {
    return (
      <Flex justifyContent="flex-start">
        <SkeletonText variant="bodySM" />
      </Flex>
    )
  }

  if (!transactions?.length) {
    return <Text alignment="left">-</Text>
  }

  return (
    <Flex justifyContent="flex-start" flexWrap="wrap">
      {transactions
        .filter((transaction) => !transaction.isVoided && !transaction.isVoid)
        .map((transaction, index) => {
          return (
            <Fragment key={transaction.id}>
              <Text alignment="left" colorVariant="primary" variant="bodySM" weight="bold">
                {!!index && <>,&nbsp;</>}
                <InvoiceTransactionLink transactionId={transaction.id} transactionNo={transaction.transactionNo} />
              </Text>
            </Fragment>
          )
        })}
    </Flex>
  )
}
